for (const inlineMenu of document.querySelectorAll('.header__inline-menu')) {
  inlineMenu.addEventListener('mouseleave', (e) => {
    inlineMenu.querySelector('header-menu>.active')?.classList.remove('active');
    inlineMenu.classList.remove('header__inline-menu--expanded');
  });
  let inlineMenuHasExpandedItem = false;
  // Header menu item
  for (const menuItem of inlineMenu.querySelectorAll('.list-menu--inline>li')) {
    menuItem.addEventListener('mouseenter', () => {
      inlineMenuHasExpandedItem = true;
      // Remove other active.
      inlineMenu.querySelector('header-menu>.active')?.classList.remove('active');
      // Is HEADER-MENU
      if (menuItem.firstElementChild?.tagName == "HEADER-MENU") {
        // Add this active.
        setTimeout(() => {
          if (inlineMenuHasExpandedItem) inlineMenu.classList.add('header__inline-menu--expanded');
        }, 300);
        window.requestAnimationFrame(() => {
          menuItem.firstElementChild?.firstElementChild?.classList.add('active');
        });
      } else {
        // Not HEADER-MENU
        inlineMenu.classList.remove('header__inline-menu--expanded');
      }
    });
  }
}

if (!customElements.get('header-account')) {
  customElements.define(
    'header-account',
    class HeaderAccount extends DetailsDisclosure {
      isCloseing = false;

      constructor() {
        super();

        this.elements = {
          HeaderAccount: this.querySelector('button'),
          summary: this.querySelector('summary'),
        };

        this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));

        this.elements.summary.addEventListener('click', (e) => {
          if (this.mainDetailsToggle.hasAttribute('open')) {
            this.closeDetails();
          } else {
            this.openDetails();
          }
          // Check if the event target is a link
          // if (e.target.tagName.toLowerCase() == 'a') {
          //     // Allow the default action
          //     return;
          // }
          e.preventDefault();
        });
        document.addEventListener('click', (e) => {
          const el = e.target.closest('header-account');
          if (!el) this.closeDetails();
        });
        this.addEventListener('mouseleave', () => {
          this.closeDetails();
        });
      }

      openDetails() {
        if (this.isCloseing) return;
        this.mainDetailsToggle.setAttribute('open', '');
      }

      closeDetails() {
        if (this.isCloseing) return;
        this.isCloseing = true;
        this.mainDetailsToggle.classList.add('closing')
        setTimeout(() => {
          this.mainDetailsToggle.removeAttribute('open');
          this.isCloseing = false;
          this.mainDetailsToggle.classList.remove('closing')
        }, 300);
      }

      toggleDetails() {
        if (!this.mainDetailsToggle.open) {
          this.elements.summary.focus();
        }
      }

    }
  );
}
